<script lang="ts">
  import type { Snippet } from 'svelte';

  import type { TeoCore } from '@/teoCore/TeoCore';

  import TeoContextProvider from './teo-context/teo-context.svelte';

  let { teoCore, children }: { teoCore?: TeoCore; children: Snippet } = $props();
  let globalCore: TeoCore | undefined = window?.__TEO__getCore?.();

  let core = $derived(teoCore ?? globalCore ?? null);
</script>

{#if core}
  {#key core}
    <TeoContextProvider teoCore={core}>
      {@render children()}
    </TeoContextProvider>
  {/key}
{/if}
